export interface SettingsMailFrom {
	id: number;
	mailAddress: string;
}

export interface AdminSettings {
	id: number;
	defaultExtractorSetId: number | null;
	defaultValidatorSetId: number | null;
	defaultOnChangeHandlerSetId: number | null;
	defaultExporterSetId: number | null;
	mailExporterSetId: number | null;
	mailFromAddresses: SettingsMailFrom[];
}

export interface ExtractorSetting {
	id: number;
	order: number;
	extractorType: number;
	settings: string;
	description: string | null;
}

export interface ExtractorSet {
	id: number;
	code: string;
	description: string;
	extractors: ExtractorSetting[];
}

export interface ValidatorSetting {
	id: number;
	order: number;
	validatorType: number;
	settings: string;
	description: string | null;
}

export interface ValidatorSet {
	id: number;
	code: string;
	description: string;
	validators: ValidatorSetting[];
}

export interface ExporterSetting {
	id: number;
	order: number;
	code: string | null;
	exporterType: number;
	settings: string;
	description: string | null;
}

export interface ExporterSet {
	id: number;
	code: string;
	description: string;
	exporters: ExporterSetting[];
}

export interface OnChangeHandlerSetting {
	id: number;
	order: number;
	onChangeHandlerType: number;
	settings: string;
	description: string | null;
}

export interface OnChangeHandlerSet {
	id: number;
	code: string;
	description: string;
	onChangeHandlers: OnChangeHandlerSetting[];
}

export const EXTRACTOR_TYPE_OPTIONS = [
	{ value: 0, label: "OpenAI Extractor" },
	{ value: 1, label: "OCR Extractor" },
	{ value: 2, label: "Filtering Extractor" },
	{ value: 3, label: "Anva Extractor" },
	{ value: 4, label: "Rule Extractor" },
	{ value: 5, label: "Aplaza Extractor" },
	{ value: 6, label: "Lambda Extractor" },
];

export const EXTRACTOR_TYPE_MAP: Record<string, number> = {
	"OPEN_AI_EXTRACTOR": 0,
	"OCR_EXTRACTOR": 1,
	"FILTERING_EXTRACTOR": 2,
	"ANVA_EXTRACTOR": 3,
	"RULE_EXTRACTOR": 4,
	"APLAZA_EXTRACTOR": 5,
	"LAMBDA_EXTRACTOR": 6,
};

export const VALIDATOR_TYPE_OPTIONS = [
	{ value: 0, label: "Anva Validator" },
	{ value: 1, label: "Audit Validator" },
	{ value: 2, label: "Rule Validator" },
	{ value: 3, label: "CED Validator" },
];

export const VALIDATOR_TYPE_MAP: Record<string, number> = {
	"ANVA_VALIDATOR": 0,
	"AUDIT_VALIDATOR": 1,
	"RULE_VALIDATOR": 2,
	"CED_VALIDATOR": 3,
};

export const EXPORTER_TYPE_OPTIONS = [
	{ value: 0, label: "Rule Exporter" },
	{ value: 1, label: "Anva Exporter" },
	{ value: 2, label: "S3 Exporter" },
	{ value: 3, label: "CSV Exporter" },
	{ value: 4, label: "CED Exporter" },
	{ value: 5, label: "SureBase Exporter" },
];

export const EXPORTER_TYPE_MAP: Record<string, number> = {
	"RULE_EXPORTER": 0,
	"ANVA_EXPORTER": 1,
	"S3_EXPORTER": 2,
	"CSV_EXPORTER": 3,
	"CED_EXPORTER": 4,
	"SUREBASE_EXPORTER": 5,
};

export const ON_CHANGE_HANDLER_TYPE_OPTIONS = [
	{ value: 0, label: "Anva OnChange Handler" },
	{ value: 1, label: "Rule OnChange Handler" },
	{ value: 2, label: "System OnChange Handler" },
];

export const ON_CHANGE_HANDLER_TYPE_MAP: Record<string, number> = {
	"ANVA_ON_CHANGE_HANDLER": 0,
	"RULE_ON_CHANGE_HANDLER": 1,
	"SYSTEM_ON_CHANGE_HANDLER": 2,
};
export interface LookupItem {
	id: number;
	type: string;
	code: string;
	description: string;
	disabled: boolean;
}
